import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BrowserQRCodeReader } from "@zxing/library";
import axios from "axios";

import Footer from "../ComponentPrimer/Footer";

const ScanQrGathering = () => {
  const [scanResult, setScanResult] = useState("Invalid");
  const [email, setEmail] = useState("Invalid"); // Ganti name menjadi email
  const [whatsapp, setWhatsapp] = useState("Invalid");
  const [modalOpen, setModalOpen] = useState(false);  // State to control modal visibility
  const [modalMessage, setModalMessage] = useState("");  // State for modal message
  const [modalType, setModalType] = useState("success");  // To determine success or failure modal
  const [isScanning, setIsScanning] = useState(true); // State to track scanning process
  const videoRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserQRCodeReader();

    const startScanning = async () => {
      try {
        // Mulai pemindaian QR Code hanya jika masih dalam status scanning
        if (isScanning) {
          const result = await codeReader.decodeFromVideoDevice(null, videoRef.current, (result, error) => {
            if (result) {
              setScanResult(result.getText());
              checkAndUpdateQRCode(result.getText());  // Proceed only if QR Code is found
              setIsScanning(false);  // Stop scanning after reading QR Code
            }
            if (error) {
              console.error("Error:", error);
              setScanResult("Invalid");
              setEmail("Invalid"); // Ganti name menjadi email
              setWhatsapp("Invalid");
            }
          });
        }
      } catch (err) {
        console.error("Failed to initialize scanner:", err);
        setScanResult("Invalid");
        setEmail("Invalid"); // Ganti name menjadi email
        setWhatsapp("Invalid");
      }
    };

    startScanning();

    // Cleanup on unmount
    return () => {
      codeReader.reset();
    };
  }, [isScanning]); // Re-run useEffect only when `isScanning` changes

  const checkAndUpdateQRCode = (qrData) => {
    if (qrData === "Invalid") {
      return;  // Don't proceed if QR code is invalid
    }

    // Cek QR Code di database
    axios
      .get(`https://rlagency.id/app/api_gathering_upi/check-qrcode.php?qrcode=${qrData}`)
      .then((response) => {
        if (response.data.exists) {
          setEmail(response.data.email);  // Ambil email dari response
          setWhatsapp(response.data.whatsapp);  // Ambil whatsapp dari response
          sendToAPI(response.data.email, response.data.whatsapp);  // Kirimkan ke API
        } else {
          setEmail("Invalid"); // Ganti name menjadi email
          setWhatsapp("Invalid");
          setScanResult("Invalid");
          showFailureModal();  // Tampilkan modal gagal jika QR code tidak ditemukan
        }
      })
      .catch((error) => {
        console.error("Error checking QR Code:", error);
        setScanResult("Invalid");
        setEmail("Invalid"); // Ganti name menjadi email
        setWhatsapp("Invalid");
        showFailureModal();  // Tampilkan modal gagal jika terjadi error
      });
  };

  const sendToAPI = (email, whatsapp) => {
    axios
      .post("https://rlagency.id/app/api_gathering_upi/self_check_in.php", {
        email: email,  // Ganti name menjadi email
        whatsapp: whatsapp,
      })
      .then((response) => {
        if (response.data.success) {
          setModalMessage(`Check-in Berhasil!`);
          setModalType("success");
        } else {
          setModalMessage("Check-in Gagal!");
          setModalType("failure");
        }
        setModalOpen(true);  // Tampilkan modal hasil
      })
      .catch((error) => {
        console.error("Error sending data to API:", error);
        setModalMessage("Check-in Gagal!");
        setModalType("failure");
        setModalOpen(true);  // Tampilkan modal gagal
      });
  };

  const showFailureModal = () => {
    setModalMessage("Log-In Gagal!");
    setModalType("failure");
    setModalOpen(true);  // Tampilkan modal gagal
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);  // Toggle modal visibility
    setIsScanning(true);  // Setelah menutup modal, aktifkan scanning lagi
    resetScan();  // Reset hasil scan setelah menutup modal
  };

  const resetScan = () => {
    setScanResult("Invalid");
    setEmail("Invalid"); // Ganti name menjadi email
    setWhatsapp("Invalid");
  };

  return (
    <div className="container">
      <div style={{ maxWidth: '700px', margin: '50px auto' }}>
        <h1 style={{ fontSize: '24px', textTransform: 'uppercase', fontWeight: '600' }}>Check In Gathering Event</h1>

        {/* Video element for QR Code scanning */}
        <div>
          <video ref={videoRef} width="100%" height="auto" style={{ border: "1px solid black" }} />
        </div>

        {/* Display scan result and email */}
        <p><strong>Email :</strong> {email}</p> {/* Ganti name menjadi email */}
        <p><strong>WhatsApp :</strong> {whatsapp}</p>

        {/* Success or Failure Modal */}
        <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
          <ModalHeader toggle={toggleModal}>{modalMessage}</ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  margin: "10px auto",
                  width: "100%",
                  maxWidth: "400px", // Batas lebar maksimal
                  textAlign: "center",
                }}
              >
                <p>
                  <strong>QR Code :</strong>
                  <br />{scanResult}
                </p>
                <p>
                  <strong>Email :</strong>
                  <br />{email} {/* Ganti name menjadi email */}
                </p>
                <p>
                  <strong>WhatsApp :</strong>
                  <br />{whatsapp}
                </p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>Close</button>
          </ModalFooter>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default ScanQrGathering;
